import { Reveal, Eyebrow } from "./Reveal";

const PARAGRAPHS = [
  "Salonee Joshi is a passionate Artist and Graphic Designer specializing in painting, sketching, and visual art. She completed a 4-year Bachelor of Visual Art (BVA) at SMRK College, Nashik, Maharashtra, where she developed her artistic skills and explored various traditional art techniques and styles.",
  "She also completed a 1-year Graphic Visual Design (GVD) course at Arena Animation, Nashik, strengthening her knowledge of visual composition, digital creativity, and graphic design.",
  "Her artwork includes canvas painting, acrylic painting, pencil sketching, portraits, nature-inspired artwork, and creative illustrations. She enjoys exploring different subjects and techniques to create expressive, detailed, and visually engaging artwork.",
];

export default function SaloneeAbout() {
  return (
    <section id="salonee" className="relative py-24 sm:py-32" data-testid="about-salonee">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-16 px-6 lg:grid-cols-12 lg:gap-12 lg:px-10">
        <div className="order-2 lg:order-1 lg:col-span-7">
          <Reveal>
            <Eyebrow>Artwith.saloni</Eyebrow>
            <h2 className="mt-6 font-serif text-3xl tracking-tight text-ink sm:text-5xl lg:text-6xl">
              Meet Salonee Rahul Joshi
            </h2>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="mt-8 max-w-2xl space-y-5 text-base leading-relaxed text-clay sm:text-lg">
              {PARAGRAPHS.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>
          </Reveal>

          <Reveal delay={0.25}>
            <div className="mt-12 grid grid-cols-1 gap-6 border-t border-linen pt-8 sm:grid-cols-3">
              {[
                ["Craft", "Painting · Sketching · Visual Art"],
                ["Education", "BVA — SMRK College, Nashik"],
                ["Design", "GVD — Arena Animation, Nashik"],
              ].map(([k, v]) => (
                <div key={k}>
                  <p className="font-mono text-[10px] uppercase tracking-[0.26em] text-vermilion">{k}</p>
                  <p className="mt-2 font-serif text-lg text-ink">{v}</p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>

        <div className="relative order-1 lg:order-2 lg:col-span-5">
          <Reveal>
            <div className="relative mx-auto w-4/5 max-w-sm lg:w-full">
              <div className="arch absolute -left-4 -top-4 h-full w-full border border-gild/50" />
              <div className="arch relative overflow-hidden bg-white p-2.5 shadow-[0_30px_60px_-24px_rgba(24,19,16,0.35)]">
                <img
                  data-testid="salonee-portrait"
                  src="/artwork/salonee-portrait.jpg"
                  alt="Salonee Rahul Joshi"
                  className="arch aspect-[4/5] w-full object-cover"
                />
              </div>
              <p className="mt-6 text-center font-mono text-[10px] uppercase tracking-[0.26em] text-sand">
                Salonee Rahul Joshi — Painting &amp; Design
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
